import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    channelList: [],
    channelArr: [],
    channelArray: [],
    channelID: "",
    selectedChannel: null,
    selectedChan: null,
    selectedCampaign: null,
    isEditing: "",

  };
  
  const mutations = {
    initializeStore(state){
      state.channelList = [];
      state.channelArr = [];
      state.channelArray = [];
      state.channelID = '';
      state.selectedChannel = null;
      state.selectedChan = null;
      state.selectedCampaign = null;
      state.isEditing = false;
    },
    SET_SELECTED_CHANNEL(state, channel) {
      state.selectedChannel = channel;
      state.isEditing = true;
    },
    CHANNELS_ARRAY(state, channel){
      state.channelArray = channel;
    },
    LIST_CAMPAIGN_CHANNELS(state, channel) {
      state.channelList = channel;
    },
    SET_SELECTED_CAMPAIGN(state, campaign) {
      state.selectedCampaign = campaign;
    },
    SET_SELECTED_CHAN(state, channel) {
      state.selectedChan = channel;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
         
      }
    },
    RESET_SEARCH_FILTERS(state){
     
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createCampaignChannel({ commit,state }, formData) {
      return axios.post('api/v1/create-campaign-channel/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchCampaignChannels({ commit,state }, formData) {
      state.channelArr = [];
      axios.post(`api/v1/get-campaign-channels/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.channelArr.push((response.data[i].channel.name + " - " + response.data[i].campaign.name));
        }
        commit('LIST_CAMPAIGN_CHANNELS', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchCampaignChannel({ commit,state }, formData) {
      axios.post(`api/v1/get-campaign-channels/`,formData)
      .then((response)=>{
        state.selectedChannel = response.data;
        const selectedCampaign = (response.data.campaign != null) ? (response.data.campaign.name)  : "";
        const selectedChannel = (response.data.channel != null) ? (response.data.channel.name)  : "";
        
        commit('SET_SELECTED_CHANNEL',response.data);
        commit('SET_SELECTED_CAMPAIGN',selectedCampaign);
        commit('SET_SELECTED_CHAN',selectedChannel);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedChannel({ commit, state }, option){
      state.channelArray = [];
      const selectedChannel = state.channelList.find(channel => (channel.channel.name + " - " + channel.campaign.name) === option);
      if (selectedChannel) {
          state.channelID = selectedChannel.campaign_channel_id;
          state.channelArray = [...state.channelArray, selectedChannel];
      }
      commit('CHANNELS_ARRAY', state.channelArray);
        
    },
  
    async updateCampaignChannel({ commit,state }, formData) {
      return axios.put(`api/v1/update-campaign-channel/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteCampaignChannel({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Channel?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Channel!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-campaign-channel/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Channel removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Channel",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Channel has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  